import jsonMakeup from './myStoreUpdated.json'

type ProductIntensity = {
    sku: string
    defaultValue: number
    min: number
    max: number
}


function getProductsWithVaryingIntensity(): ProductIntensity[] {
    let result: ProductIntensity[] = []

    for (let makeup of jsonMakeup) {
        if (makeup.opacityLimits) {
            result.push({
                sku: makeup.sku,
                defaultValue: makeup.opacity,
                min: makeup.opacityLimits.min,
                max: makeup.opacityLimits.max,
            });
        }
    }

    return result
}

export { getProductsWithVaryingIntensity }
export type { ProductIntensity }